import { apiClient, ExtendedAxiosResponse } from 'helpers/apiClient';

export const api = {
  cancelClaim: (
    url: string,
    currentStep: number,
    invoiceNumber: string,
    claimId?: number,
    serviceId?: number | null
  ): Promise<ExtendedAxiosResponse> =>
    apiClient.post(
      `${url}/claimStep${currentStep}/cancelClaim`,
      {},
      {
        params: {
          invoicenumber: invoiceNumber,
          claimid: claimId,
          serviceid: serviceId,
        },
      }
    ),
};
